import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import Tooltip from '@/tooltip';
import { Actions as OVERTIMEACTIONS } from '@/redux/actions/overtimeActions';
import { validateFloat } from '@/common/validation/Validators';

const typeOptions = [
    { label: 'Paid', value: false },
    { label: 'Time Off in Lieu', value: true },
];

const AdvancedOvertime = ({ overtime, updateSetting, disabled, jurisdiction }) => {

    return (
        <React.Fragment>
            <div className='col-xs-12 pr-0 pl-0'>
                <div className='col-xs-12 pr-0 pl-0' style={{ marginBottom: 15 }}>
                    <h5>Basic Overtime Options</h5>
                </div>
                <div className="col-xs-6 pl-0" style={{ paddingLeft: 0 }}>
                    <div className="form-material">
                        <input
                            id="overtime-type-name"
                            className="form-control form-input"
                            disabled={disabled}
                            name="name"
                            onChange={(e) => updateSetting(overtime.id, e.target.name, e.target.value)}
                            defaultValue={overtime.name}
                        />
                        <label htmlFor="overtime-type-name">Name</label>
                    </div>
                </div>

                <div className="col-xs-3">
                    <div className="form-material">
                        <input
                            id="overtime-type-rate"
                            className="form-control valid form-input"
                            type="text"
                            name="rate"
                            disabled={disabled}
                            onChange={(e) => updateSetting(overtime.id, e.target.name, validateFloat(e.target.value))}
                            defaultValue={overtime.rate}
                        />
                        <label htmlFor="overtime-type-rate">Rate</label>

                        {/* <div className="help-block animated fadeInDown first-overtime-type-rate hide">
              Now, enter a multiplier (e.g. 1, 1.5) of the original salary -
              this is the rate at which this Overtime will be paid.
            </div> */}

                    </div>
                </div>

                <div className="col-xs-3 pr-0">
                    <div className="form-material">
                        <Select
                            valueName="selected"
                            options={typeOptions}
                            value={typeOptions.find((item) => item.value == overtime.isToil)}
                            placeholder="Choose one"
                            isDisabled={disabled}
                            onChange={(e) => updateSetting(overtime.id, "isToil", e.value)}
                        />
                        <label htmlFor="material-text">Type</label>

                        <div className="clearfix" />
                    </div>
                </div>
            </div>

            {
                jurisdiction == 'UK' &&
                <div className='col-xs-12 pr-0 pl-0' style={{ marginTop: 20 }}>
                    <div className='col-xs-12 pr-0 pl-0' style={{ marginBottom: 15 }}>
                        <h5>Pay Item Treatment</h5>
                    </div>

                    <div className="col-xs-6 pl-0">
                        <label className="css-input switch switch-sm switch-success">
                            <input
                                id="notOTTax"
                                type="checkbox"
                                checked={!!overtime.pensionable}
                                onChange={() => updateSetting(overtime.id, "pensionable", !overtime.pensionable)}
                            />
                            <span></span>
                            <label htmlFor="notOTTax" style={{ marginBottom: 0 }}>Include in Pensionable Income</label>

                        </label>
                    </div>
                </div>
            }

            <div className='col-xs-12 pr-0 pl-0' style={{ marginTop: 20 }}>
                <div className='col-xs-12 pr-0 pl-0' style={{ marginBottom: 15 }}>
                    <h5>Time & Attendance Rule Options</h5>
                </div>


                {
                    jurisdiction == 'MT' &&
                    <div className="col-xs-6 pl-0">
                        <label className="css-input switch switch-sm switch-success">
                            <input
                                id="notOTTax"
                                type="checkbox"
                                checked={!!overtime.notOTTax}
                                onChange={() => updateSetting(overtime.id, "notOTTax", !overtime.notOTTax)}
                            />
                            <span></span>
                            <label htmlFor="notOTTax" style={{ marginBottom: 0 }}>Not Eligible for Overtime Tax</label>

                        </label>
                    </div>
                }

                <div className="col-xs-6 pl-0">
                    <label className="css-input switch switch-sm switch-success">
                        <input
                            id="applyNext"
                            type="checkbox"
                            checked={!!overtime.applyNext}
                            onChange={() => updateSetting(overtime.id, "applyNext", !overtime.applyNext)}
                        />
                        <span></span>
                        <Tooltip content='Apply other overtime rules after this one'>
                            <label htmlFor="applyNext" style={{ marginBottom: 0 }}>Include Other Overtimes in Rules</label>
                        </Tooltip>

                    </label>
                </div>

                <div className="col-xs-6 pl-0">
                    <label className="css-input switch switch-sm switch-success">
                        <input
                            id="doNotTreatAsOT"
                            type="checkbox"
                            checked={!!overtime.doNotTreatAsOT}
                            onChange={() => updateSetting(overtime.id, "doNotTreatAsOT", !overtime.doNotTreatAsOT)}
                        />
                        <span></span>
                        <Tooltip content='Timesheet hours to not be flagged as OT (hence basic will be applied too)'>
                            <label htmlFor="doNotTreatAsOT" style={{ marginBottom: 0 }}>Apply Basic Hours & Overtime</label>
                        </Tooltip>
                    </label>
                </div>

                <div className="col-xs-6 pl-0">
                    <label className="css-input switch switch-sm switch-success">
                        <input
                            id="treatAsAllowance"
                            type="checkbox"
                            checked={!!overtime.treatAsAllowance}
                            onChange={() => updateSetting(overtime.id, "treatAsAllowance", !overtime.treatAsAllowance)}
                        />
                        <span></span>
                        <Tooltip content={`Treat as an ${jurisdiction == 'UK' ? 'Pay Item' : 'Allowance'} - For Sunday OT @ 1 to also pay as basic hours`}>
                            <label htmlFor="treatAsAllowance" style={{ marginBottom: 0 }}>Treat As {jurisdiction == 'UK' ? 'Pay Item' : 'Allowance'}</label>
                        </Tooltip>
                    </label>
                </div>

                <div className="col-xs-6 pl-0">
                    <label className="css-input switch switch-sm switch-success">
                        <input
                            id="deductSundayFromBasic"
                            type="checkbox"
                            checked={!!overtime.deductSundayFromBasic}
                            onChange={() => updateSetting(overtime.id, "deductSundayFromBasic", !overtime.deductSundayFromBasic)}
                        />
                        <span></span>
                        <Tooltip content='Sunday Hours paid @2 are part of basic hours'>
                            <label htmlFor="deductSundayFromBasic" style={{ marginBottom: 0 }}>Deduct Sunday From Basic</label>
                        </Tooltip>
                    </label>
                </div>

            </div>
        </React.Fragment>
    );
};
const mapStateToProps = (state, ownProps) => {

    const overtimeId = state.company?.advancedSettingsModal?.id

    return {
        jurisdiction: state.company?.settings?.jurisdiction,
        overtime: state.company?.settings?.overtimes?.find(overtime => overtime.id == overtimeId)
    }
}

const mapDispatchToProps = (dispatch) => ({
    updateSetting: (id, field, newValue) => dispatch(OVERTIMEACTIONS.updateSetting(id, field, newValue, false)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AdvancedOvertime)